/**
 * Styled Components - Created by david on 12/02/18.
 */
import styled from 'styled-components'
import Popover from 'antd/lib/popover'
import Tooltip from 'antd/lib/tooltip'
import { BLACK } from '../../theme/colors'
import Icon from 'antd/lib/icon'

interface DivProps {
  wide?: boolean
  secondary?: boolean
  withCheckbox?: boolean
}

export const Container = styled.div`
  list-style: none;
  display: inline-block;
  width: calc(100% / ${({ wide }: DivProps) => wide ? '4' : '2'});
  padding: 0px 4px;
  &.locker-modal {
    font-family: "Avenir Next";
    width: 176px;
    max-height: 320px;
    border-radius: 8px;
    border: 1px solid #D7D1D2;
    background: #FFF;
    margin-top: 12px;
    margin-right: 12px;
    padding-inline: 0;
    cursor: pointer;
    opacity: ${({ secondary}: DivProps) => secondary ? '0.5' : '1'};
    .footerDiv {
      padding: 8px;
    }
    .typeDiv {
      color: #302628;
      font-weight: 600;
      white-space: nowrap;
      width: auto;
    }
    .desc {
      font-weight: normal;
    }
  }
  &.checked {
    border: 3px solid #2196F3;
  }
  @media (min-width: 320px) and (max-width: 480px) {
    width: ${({ withCheckbox }: DivProps) => withCheckbox ? 'calc(95% / 2)' : '230px'};
    margin-left: 6px;
    ${({ withCheckbox }: DivProps) => !withCheckbox ? `
      margin: 0 auto;
      display: block;
    ` : ''}
    &.locker-modal {
      width: calc(50% - 12px);
      margin-right: 18px;
      margin-left: 0;
      &:nth-child(2n) {
        margin-right: 0;
      }
    }
  }
`

export const Footer = styled.div`
  padding: 4px;
  font-family: Avenir;
`

export const QuickView = styled.img``

export const Type = styled.div`
  color: ${BLACK};
  font-size: 14px;
  line-height: 19px;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 220px;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`
export const Description = styled.div`
  color: ${BLACK};
  font-size: 12px;
  font-weight: bold;
  line-height: 16px;
  padding: 2px 0px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 220px;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const CodeLabel = styled.div`
  color: #787878;
  font-size: 12px;
  line-height: 16px;
  padding-bottom: 2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 220px;

  @media (min-width: 320px) and (max-width: 480px) {
    width: 100%;
  }
`

export const InfoContainer = styled.div`
  user-select: none;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
`

export const Date = styled.div`
  user-select: none;
  color: #5f6062;
  font-size: 12px;
  line-height: 16px;
`

export const StateIndicator = styled.div`
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  top: 8px;
  left: 8px;
  width: 24px;
  height: 24px;
  border-radius: 50px;
  background: #302628;
  z-index: 5;
  color: #FFF;
  font-family: "Avenir Next";
  font-size: 14px;
  font-weight: 600;
`

export const ThumbnailDiv = styled.div`
  position: relative;
  border-top-left-radius: 8px;
  border-top-right-radius: 8px;
  overflow: hidden;
`

export const StatusFlag = styled.img`
  position: absolute;
  height: 36px;
  right: 4px;
  top: 3px;
  z-index: 8;
  border-top-right-radius: 5px;
`

export const StyledTooltip = styled(Popover)``

export const TooltipContent = styled.div`
  max-width: 398px;
`

export const StatusIcon = styled.img`
  float: right;
  max-width: 78px;
  margin-left: 8px;
`

export const TooltipBody = styled.div`
  padding-top: 16px;
  padding-left: 8px;
  padding-right: 10px;
  @media (max-width: 767px) {
    padding-top: 30px;
    padding-left: 19px;
    padding-right: 17px;
  }
`

export const ButtonContainer2 = styled.div`
  display: flex;
  flex-flow: column;
  align-items: center;
  justify-content: center;
  left: 0;
  position: absolute;
  top: calc(50% - 14px);
  user-select: none;
  width: 100%;
  z-index: 2;
  transition: all .25s;
  &:hover {
    cursor: pointer;
  }
`

export const StyledPopOver = styled(Tooltip)`
  cursor: pointer;
`

export const PopoverText = styled.div`
  max-width: 256px;
  width: 100%;
  font-size: 12px;
  color: ${BLACK};
`

export const CertificationButton = styled.div`
  user-select: none;
  background-color: #ffee6dad;
  font-size: 12px;
  line-height: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  padding: 6px 16px;
  width: 87%;
  margin-top: 10px;
  transition: all .25s;
  &:hover {
    cursor: pointer;
    background-color: #ffee6dd9;
  }
`

export const ImportedIcon = styled(Icon)`
  font-size: 12px;
  position: absolute;
  right: ${({ secondary }: DivProps) => secondary ? '48px' : '7px'};
  top: -9px;
  z-index: 7;
  transform: rotate(-90deg);
  background: white;
  color: #7c61b4;
  border-radius: 25px;
  padding: 4px;
  border: 1px solid #ece3ff;
  box-shadow: none;
`


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--5!./src/components/ProductThumbnailStore/styledComponents.tsx